// 组件对象，大写
import inputJson from './inputJson.vue'
export default inputJson
